import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import taxActions from '../../actions/tax.actions';
import PayoutSection from './sections/PayoutSection';
import TaxProfileSection from './sections/TaxProfileSection';
import SocialSection from './sections/SocialSection';
import ConsentSection from './sections/ConsentSection';
import CreatorCodeSection from './sections/CreatorCodeSection';
import {hasRejectedNewTermsWithVBucks} from '../../utils/ValidationUtils';
import {SettingsViewProps} from './SettingsView';
import {selectPayout, selectClosedAccount} from '../../selectors';
import {TaxAccountStatus} from '../../../shared/types';

//@ts-ignore
import styles from './Settings.pcss';

export type SettingsProps = SettingsViewProps;

const Settings: React.FC<SettingsProps> = ({taxState, affiliateAccount, configState, messages}) => {
    const [mounted, setMounted] = useState(false);
    const dispatch = useDispatch();
    const payoutState = useSelector(selectPayout);
    const rejectedInVBucks = useSelector(state =>
        hasRejectedNewTermsWithVBucks(selectClosedAccount(state))
    );

    const {loadingAcceptance, closedAccount} = payoutState || {};
    const {acceptanceStatus} = closedAccount || {};
    const {createAble, submitted, isConsent} = taxState || {};

    useEffect(() => {
        dispatch(taxActions.getAccountStatus());
        setMounted(true);
    }, []);

    if (!mounted) return null;

    const sections = [
        <CreatorCodeSection
            key="CreatorCodeSection"
            messages={messages}
            creatorCode={affiliateAccount.slug}
            configState={configState}
        />,
        <SocialSection
            key="SocialSection"
            messages={messages}
            affiliate={affiliateAccount}
            configState={configState}
        />,
        taxState.taxStatus === TaxAccountStatus.TAX_VERIFIED && (
            <PayoutSection
                key="PayoutSection"
                messages={messages}
                taxState={taxState}
                configState={configState}
                payoutState={payoutState}
            />
        ),
        submitted && !isConsent && !rejectedInVBucks && (
            <ConsentSection key="ConsentSection" rejectedInVBucks={rejectedInVBucks} />
        ),
        !rejectedInVBucks && (
            <TaxProfileSection
                key="TaxProfileSection"
                loadingAcceptance={loadingAcceptance}
                createAble={createAble}
                acceptanceStatus={acceptanceStatus}
            />
        )
    ];

    return (
        <div className={styles.wrapper}>
            <div className={styles.sections}>
                {sections.map((section, index) => {
                    return (
                        section && (
                            <div key={`section-${index}`} className={styles.section}>
                                {section}
                            </div>
                        )
                    );
                })}
            </div>
        </div>
    );
};

export default Settings;
